var exports = {
  "pz": "RecentMentionsContent.module__filterButton___V0IyVE",
  "Pt": "RecentMentionsContent.module__filterButtonActive___V0IyVE",
  "XG": "RecentMentionsContent.module__scroller___V0IyVE",
  "bm": "RecentMentionsContent.module__guildGroup___V0IyVE",
  "W1": "RecentMentionsContent.module__messageCard___V0IyVE",
  "v0": "RecentMentionsContent.module__iconMedium___V0IyVE",
};

module.exports = exports;
